import { render, staticRenderFns } from "./EmailSubscribeDialog.vue?vue&type=template&id=20064e01"
import script from "./EmailSubscribeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailSubscribeDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports